




























import Vue from 'vue'
import voteIcon from './voteIcon.vue'
import {
  MESSAGE_VOTE_TYPE_YESNO,
  MESSAGE_VOTE_TYPE_STARS5,
  MESSAGE_VOTE_TYPE_LIKE,
  MESSAGE_VOTE_RESULT_YES,
  MESSAGE_VOTE_RESULT_NO,
  MESSAGE_VOTE_RESULT_1,
  MESSAGE_VOTE_RESULT_2,
  MESSAGE_VOTE_RESULT_3,
  MESSAGE_VOTE_RESULT_4,
  MESSAGE_VOTE_RESULT_5,
  MESSAGE_VOTE_RESULT_LIKE
} from '@/constants'

interface IVoteType {
  val: string
}

const MESSENGER__VOTE_RESULT_TYPES: {[key: string]: IVoteType[]} = {
  [MESSAGE_VOTE_TYPE_YESNO]: [
    {
      val: MESSAGE_VOTE_RESULT_YES
    },
    {
      val: MESSAGE_VOTE_RESULT_NO
    }
  ],
  [MESSAGE_VOTE_TYPE_STARS5]: [
    {
      val: MESSAGE_VOTE_RESULT_1
    }, {
      val: MESSAGE_VOTE_RESULT_2
    }, {
      val: MESSAGE_VOTE_RESULT_3
    }, {
      val: MESSAGE_VOTE_RESULT_4
    }, {
      val: MESSAGE_VOTE_RESULT_5
    }
  ],
  [MESSAGE_VOTE_TYPE_LIKE]: [
    {val: MESSAGE_VOTE_RESULT_LIKE}
  ]
}

export default Vue.extend({
  components: {
    voteIcon
  },
  props: {
    type: String,
    ans: String
  },
  data () {
    return {
      vote: [] as IVoteType[]
    }
  },
  methods: {
    setVote (): void {
      const vote = MESSENGER__VOTE_RESULT_TYPES[this.type]
      if (vote) {
        this.vote = vote
      } else {
        console.error('Unknown vote type!', this.type)
      }
    },
    isActiveItem (val: string): boolean {
      return val === this.ans
    }
  },
  mounted () {
    this.setVote()
  }
})
